import {
  useState,
  useCallback,
  // useRef
} from 'react';
import { useTranslation } from 'react-i18next';
import { VStack } from 'components/muiComponents/stack';
// import noClaims from 'assets/images/no-claims.svg';
// import download from 'assets/images/download.svg';
import paymentFps from 'assets/images/FPS.svg';
import creditCard from 'assets/images/f47-credit-card.svg';
import bank from 'assets/images/Bank transfer.svg';
// import { captureRef } from 'react-native-div-shot';
import { useLocation, useNavigate } from 'react-router-dom';
import arrowClose from 'assets/images/arrow-close.svg';
import arrowOpen from 'assets/images/arrow-open.svg';
import plus from 'assets/images/plus.svg';
import minus from 'assets/images/minus.svg';
// import { Accordion } from './accordion';
import { useEffect } from 'react';
// import { MyClaimsStackParamList } from '@navigation';
// import { WebData } from 'contexts/common/webData';
import { styles } from './styles';
// import { getConfig } from 'configs';
import { MessageType } from 'models/MessageType';
import { localStorageService } from 'utils/LocalStorageService';
import { message } from 'antd';

import { useKeycloakReady } from 'hooks';
// import { useGetSettleDescription } from '../utils';
// import { useViewShortfalls } from 'all-in-one-shared-api';
// import { useKeycloak } from 'all-in-one-react-keycloak';
import {
  usePaymentCompanyName,
  useLifeCreditCardPayment,
  useLifeUserPaymentDetail,
  useLifePayTips,
} from 'all-in-one-shared-api';
// import { get } from 'lodash';
// import styled from 'styled-components';
import { changeDataFun, isLocaleEnglish } from 'utils';
import { Typography, Button } from 'antd';
// import { FPSPanelContent } from './components/FPSPanelContent';
// import html2canvas from 'html2canvas';
import GreetingSection from '../../components/navbar/GreetingSection';
import styled from 'styled-components';
import { sessionStorageService } from 'utils/SessionStorageService';

export const ResponsiveContainer = styled.div`
  padding-left: 356px;
  padding-right: 356px;
  background-color: pink;

  @media (max-width: 1400px) and (min-width: 1200px) {
    padding-left: 300px;
    padding-right: 300px;
  }
  @media (max-width: 1200px) and (min-width: 992px) {
    padding-left: 200px;
    padding-right: 200px;
  }
  @media (max-width: 992px) and (min-width: 768px) {
    padding-left: 100px;
    padding-right: 100px;
  }
  @media (max-width: 768px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

interface ResponseProps {
  i18nType: string;
  i18nKey: string;
  langZhCn: string;
  langEn: string;
  langZhTw: string;
  i18nOrder: number;
}

export const PaymentDetailsScreen = () => {
  const [randoms, setRandoms] = useState(0);
  const location = useLocation() as {
    state: {
      policyNumber: string;
      paymentStateCode: string;
      companyCode: string;
    };
  };
  const { policyNumber, companyCode, paymentStateCode } = location.state;
  const [expanded, setExpanded] = useState(false);
  const [expanded0, setExpanded0] = useState(false);
  const [expanded1, setExpanded1] = useState(false);
  const [expanded2, setExpanded2] = useState(false);
  const [payTips, setPayTips] = useState<ResponseProps[]>([]);
  // const toggleExpand = () => {
  //   setExpanded((show) => !show);
  // };
  // const { keycloak } = useKeycloak();
  // const [showModal, setShowModal] = useState(false);
  // const [showSnackBar, setShowSnackBar] = useState(false);
  // const [snackBarMessage, setSnackBarMessage] = useState('');
  // const { memberType } = get(keycloak, 'tokenParsed', {
  //   name: '',
  //   given_name: '',
  //   family_name: '',
  //   memberType: '',
  // });
  // const { data: claimData /*, isLoading: claimIsLoading */ } = useViewShortfalls({
  //   authToken: keycloak.token,
  //   memberType,
  //   config: { refreshInterval: 1000 * 60 },
  // });
  const navigate = useNavigate();
  const convertDate = (dateStr: string): string => {
    const monthMap: { [key: string]: string } = {
      Jan: '01',
      Feb: '02',
      Mar: '03',
      Apr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Aug: '08',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dec: '12',
    };

    // 拆分日期字符串
    const [day, month, year] = dateStr.split('-');

    // 格式化成YYYYMMDD
    const formattedDate = `${year}${monthMap[month]}${day.padStart(2, '0')}`;
    return formattedDate;
  };
  const { token, ready } = useKeycloakReady();
  const convertDate2 = (inputDate: string) => {
    // 创建一个日期对象
    const months = {
      Jan: '01',
      Feb: '02',
      Mar: '03',
      Apr: '04',
      May: '05',
      Jun: '06',
      Jul: '07',
      Aug: '08',
      Sep: '09',
      Oct: '10',
      Nov: '11',
      Dec: '12',
    };

    // 使用正则表达式解析输入的日期字符串
    const regex = /^(\d{1,2})-([A-Za-z]{3})-(\d{4})$/;
    const match = inputDate.match(regex);

    if (match) {
      const day = match[1];
      const month = months[match[2] as keyof typeof months];
      const year = match[3];

      // 生成目标格式的日期字符串
      return `${day}/${month}/${year}`;
    } else {
      throw new Error('Invalid date format');
    }
  };
  const { i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { data: paymentDetail, /*error,*/ shouldFetch: shouldDetailFetch } = useLifeUserPaymentDetail(
    token ?? '',
    policyNumber,
  );
  const { data: companyNameData, shouldFetch: companyNameShouldFetch } = usePaymentCompanyName(
    token ?? '',
    companyCode,
  );
  const [paymentType, setPaymentType] = useState<string>(''); // 初始化 paymentType 状态
  const premiumDueDate = paymentDetail?.premiumDueDate || '20-Sep-2024';
  const currency = isEnglish ? paymentDetail?.currencyDesc : paymentDetail?.currencyDescTc || 'USD';
  const hkdCurrency = isEnglish ? paymentDetail?.hkdCurrencyDesc : paymentDetail?.hkdCurrencyDescTc || 'HKD';
  const premiumAmount = paymentDetail?.premiumAmount || '0.00';
  const semiAnnualPremiumAmount = paymentDetail?.semiAnnualPremiumAmount || '0.00';
  const levyAmount = paymentDetail?.levyAmount || '0.00';
  const discountAmount = paymentDetail?.discountAmount || '0.00';
  const premiumAmountHKD = paymentDetail?.premiumAmountHKD || '0.00';
  const exchangeRate = paymentDetail?.exchangeRate || '0.00';
  const exchangeDate = paymentDetail?.exchangeDate || '22-Sep-2024';
  const inactiveAutoPayAccount = paymentDetail?.inactiveAutoPayAccount || 'N';
  // const requestPart0 = {
  //   paymentType: 'FPS',
  //   companyCode: companyCode,
  //   premiumDueDate: convertDate2(premiumDueDate),
  //   policyNumber: policyNumber,
  // };
  // const FPS_MCC = '0000';
  // const FPS_CURRENCY = '344';
  // const FPS_ID = '5169909';
  // const {
  //   data: paymentCompleteData,
  //   /*error: paymentCompleteError,isLoading,*/
  //   shouldFetch: shouldCompleteFetch,
  // } = usePaymentComplete('FPS', token ?? '', requestPart0);
  const [requestPart, setRequestPart] = useState({
    paymentType: paymentType,
    companyCode: companyCode,
    premiumDueDate: convertDate2(premiumDueDate),
    policyNumber: policyNumber,
    uploadFlag: true,
  });
  // const {
  //   data: paymentProofData,
  //   /*error: paymentProofError,isLoading,*/
  //   shouldFetch: shouldProofFetch,
  // } = usePaymentProof('payment-proof', keycloak.token, requestPart, {
  //   shouldRetryOnError: false,
  // });
  // useEffect(() => {
  //   console.log('paymentDetail', paymentDetail);
  // }, [paymentDetail]);
  // const shortfalls = useMemo(() => {
  //   if (!claimData?.results) return [];

  //   return claimData.results.filter((claim) => claim.claimStatus === 'SHORTFALL');
  // }, [claimData?.results]);
  const { Text } = Typography;
  // const config = getConfig(process.env.APP_ENVIRONMENT);
  // const handleDownloadQRCode = () => {
  //   if (qrCodeRef.current) {
  //     html2canvas(qrCodeRef.current).then((canvas) => {
  //       const link = document.createElement('a');
  //       link.href = canvas.toDataURL(); // 转换为图片URL
  //       link.download = 'qrcode.png'; // 设置文件名
  //       link.click(); // 触发下载
  //     });
  //   }
  // };
  const handleUpload = useCallback(
    (MethodValue: string) => {
      console.log('MethodValue', MethodValue);
      setPaymentType(MethodValue === 'FPS' ? 'FPS' : MethodValue === 'Bank' ? 'BANK_TRANSFER' : 'CREDIT_CARD');
      if (paymentType != '') {
        console.log('--------------paymenttype', paymentType);
        setRequestPart({
          paymentType: paymentType,
          companyCode: companyCode,
          premiumDueDate: convertDate2(premiumDueDate),
          policyNumber: policyNumber,
          uploadFlag: true,
        });
        navigate('/LIPayment/LifePaymentUpload', {
          state: {
            paymentType: paymentType,
            requestPart: requestPart,
            policyNumber: policyNumber,
          },
        });
      }
    },
    [paymentType, companyCode, navigate, policyNumber, premiumDueDate, requestPart],
  );

  useEffect(() => {
    if (paymentType != '') {
      console.log('--------------paymenttype', paymentType);
      setRequestPart({
        paymentType: paymentType,
        companyCode: companyCode,
        premiumDueDate: convertDate2(premiumDueDate),
        policyNumber: policyNumber,
        uploadFlag: true,
      });
      const lastPayment = JSON.stringify({
        inactiveAutoPayAccount,
        policyNumber,
      });
      localStorageService.set('LastPayment', lastPayment);
      navigate('/LIPayment/LifePaymentUpload', {
        state: { paymentType: paymentType, requestPart: requestPart, policyNumber: policyNumber },
      });
    }
  }, [paymentType, companyCode, navigate, policyNumber, premiumDueDate, requestPart, inactiveAutoPayAccount]);

  // const handleComplete = useCallback(() => {
  //   shouldCompleteFetch(true);
  // }, [shouldCompleteFetch]);
  // useEffect(() => {
  //   if (paymentCompleteData?.success) {
  //     console.log('paymentCompleteData', paymentCompleteData);
  //     navigate('/LIPayment');
  //   }
  // }, [paymentCompleteData, navigate]);
  // const claimIdsStr = shortfalls
  //   .map((c) => `${c.claimId}${c.sequenceNo ? '-' + c.sequenceNo : ''}`)
  //   .join(',');
  // const settleDescription = useGetSettleDescription(claimIdsStr);
  // console.log('shortfalls', shortfalls);
  // console.log('settleDescription', settleDescription);
  // console.log('token', token);
  // console.log('config', config.paymentReturnUrl);
  // const [navigating, setNavigating] = useState(false);
  const { t } = useTranslation();
  const description = `${policyNumber}|${convertDate(premiumDueDate)}`;
  const [paymentMethod, setPaymentMethods] = useState<string>('CARD_EWALLET');
  const { data: creditCardData, shouldFetch: shouldCreditCardFetch } = useLifeCreditCardPayment(
    'useLifeCreditCardPayment' + randoms,
    policyNumber,
    description,
    paymentMethod,
    token ?? '',
    i18n.language == 'en' ? 'en' : 'tc',
    'web',
  );
  const { data: payTipsData, shouldFetch: shouldPayTipsFetch } = useLifePayTips(
    'useLifePayTips',
    token ?? '',
    'life_payment_remark',
  );
  useEffect(() => {
    if (randoms) {
      shouldCreditCardFetch(true);
    }
  }, [randoms, shouldCreditCardFetch]);
  useEffect(() => {
    if (token) shouldPayTipsFetch(true);
  }, [token, shouldPayTipsFetch]);
  useEffect(() => {
    if (payTipsData) {
      // 根据i18nOrder字段从小到大排序
      shouldPayTipsFetch(false);
      setPayTips([...payTipsData].sort((a, b) => a.i18nOrder - b.i18nOrder));
    }
  }, [payTipsData, payTips, shouldPayTipsFetch]);
  const navigateToCreditCardPayment = useCallback(
    (type?: string) => {
      sessionStorageService.set('over4', (Number(premiumAmountHKD.replace(/,/g, '')) >= 400000).toString());
      sessionStorageService.set(
        'uploadData',
        JSON.stringify({
          paymentType: '',
          companyCode: companyCode,
          premiumDueDate: convertDate2(premiumDueDate),
          policyNumber: policyNumber,
          uploadFlag: true,
        }),
      );
      if (type == 'FPS') {
        //設置新type

        // if (Number(premiumAmountHKD.replace(/,/g, '')) >= 400000)

        setPaymentMethods('FPS');
      } else {
        setPaymentMethods('CARD_EWALLET');
      }
      setRandoms(Math.random());
      shouldCreditCardFetch(true);
    },
    [setRandoms, shouldCreditCardFetch, companyCode, policyNumber, premiumDueDate, premiumAmountHKD],
  );
  useEffect(() => {
    // console.log('222222222222222222');
    try {
      if (!ready) return;
      // console.log('00000000000000000000');
      // setNavigating(true);

      if (!(creditCardData?.message && creditCardData?.referenceNo)) return;

      // store lastPayment info for redirection
      const lastPayment = JSON.stringify({
        referenceNo: creditCardData?.referenceNo,
        inactiveAutoPayAccount: inactiveAutoPayAccount,
        policyNumber,
      });
      localStorageService.set('LastPayment', lastPayment);
      // navigate to payment gateway
      // console.log('111111111111111');
      window.open(creditCardData?.message, '_self');
    } catch (err) {
      const error = (err as Error).toString();
      message[MessageType.ERROR](error.toString(), 5);
      // setNavigating(false);
    }
  }, [creditCardData, ready, policyNumber, inactiveAutoPayAccount]);

  // const navigateToCreditCardPayment = useCallback(() => {
  //   // Logic for navigating to credit card payment
  //   setRandoms(Math.random());
  //   try {
  //     console.log('11111');
  //     // console.log('data', data);
  //     // if (!creditCardData?.message) return;
  //     const webData = {
  //       title: t('shortfallPayment.title'),
  //       link: creditCardData?.message,
  //       handleRedirection: (url: string) => {
  //         if (url && url.startsWith(config.paymentReturnUrl ?? '')) {
  //           // TODO get payment reference No from redirection url
  //           // console.log('33333');
  //           // navigation.replace('LifePaymentFlow', {
  //           //   screen: 'LifePaymentSuccessScreen',
  //           //   params: {
  //           //     referenceNo: creditCardData.referenceNo,
  //           //   },
  //           // });
  //         }
  //       },
  //     };
  //     console.log('webData', webData);
  //     // navigation.navigate('LifeWebScreen', { data: webData });
  //   } catch (error) {
  //     console.log('err', error);
  //     // navigation.replace('MyClaimsScreen', {
  //     //   screen: 'ShortfallPaymentFailedScreen',
  //     // });
  //   }
  // }, [config, creditCardData, t]);

  // const qrCodeRef = useRef(null);

  useEffect(() => {
    // 设置 shouldFetch 为 true 来触发请求
    shouldDetailFetch(true);
  }, [shouldDetailFetch]);
  // useEffect(() => {
  //   // 设置 shouldFetch 为 true 来触发请求
  //   shouldCreditCardFetch(true);
  // }, [shouldCreditCardFetch]);
  useEffect(() => {
    companyNameShouldFetch(true);
  }, [companyNameShouldFetch]);
  interface SurgeryItem {
    id: number;
    title: string;
    description?: string; // 将 description 设为可选
    step1?: string;
    step2?: string;
    description2?: string;
    description3?: string;
  }
  const surgeryData = [
    {
      id: 1,
      title: t('Payment.fpsTitle'),
      // subtitle: 'Update Payment Arrangement',
      step1: t('Payment.Step1'),
      step2: t('Payment.Confirm payment'),
      // description: t('Payment.ScanQRDescription'),
      description: t('Payment.AuthorizedDescription'),
      description2: t('Payment.MerchantDescription', {
        companyName: isEnglish ? companyNameData?.companyName : companyNameData?.companyNameTC,
      }),
      description3: t('Payment.confirmDesc'),
    },
    {
      id: 2,
      title: t('Payment.CreditCard'),
      // subtitle: 'Proof of Payment Received',
      description: t('Payment.CreditCardDescription'),
      description1: t('Payment.CreditCardDescription1'),
      description2: t('Payment.CreditCardDescription2'),
      description3: t('Payment.CreditCardDescription3'),
    },
    {
      id: 3,
      title: t('Payment.BankTransfer'),
      // subtitle: 'Update Payment Arrangement',
      // description: t('Payment.uploadProofDescription', {
      //   beneficiaryName: beneficiaryName,
      //   beneficiaryBankName: beneficiaryBankName,
      //   bankAddress: bankAddress,
      //   swiftCode: swiftCode,
      //   bankCode: bankCode,
      //   branchCode: branchCode,
      //   bankAccountNumber: bankAccountNumber,
      // }),
      description2: t('Payment.uploadProofDescription2'),
    },
  ];
  // const handleDownload = async () => {
  // const permissionResp = await requestPermissionsAsync(true);
  // if (permissionResp.granted) {
  //   try {
  //     const uri = await captureRef(qrCodeRef);
  //     setSnackBarMessage(t('documents.downloadSuccess'));
  //     await saveToLibraryAsync(uri);
  //   } catch (error) {
  //     console.error('捕获二维码失败:', error);
  //     setSnackBarMessage(t('documents.downloadFailed'));
  //   }
  //   setShowSnackBar(true);
  //   console.log('Number(premiumAmountHKD)', premiumAmountHKD);
  // }
  //下载二维码
  // };

  console.log('companyNameData?.companyName', companyNameData?.companyName);
  const toggleExpanded = useCallback((index: number) => {
    if (index === 0) {
      setExpanded0((prev) => !prev);
    } else if (index === 1) {
      setExpanded1((prev) => !prev);
    } else if (index === 2) {
      setExpanded2((prev) => !prev);
    }
  }, []);
  const renderClassificationItem = useCallback(
    ({ item, index }) => (
      <>
        <div>
          <div
            style={{
              borderBottom: '1px solid #ccc',
              // onClick={toggleExpand},
              // backgroundColor: 'pink',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: 'white',
                padding: 16,
                height: 64,
              }}
              onClick={() => toggleExpanded(index)}
            >
              <div style={{ flex: 1 }}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  {index === 0 ? (
                    <img src={paymentFps} alt="FPS" style={{ width: 24, height: 24, marginRight: 8 }} />
                  ) : index === 1 ? (
                    <img src={creditCard} alt="Credit Card" style={{ width: 24, height: 24, marginRight: 8 }} />
                  ) : index === 2 ? (
                    <img src={bank} alt="Bank Transfer" style={{ width: 24, height: 24, marginRight: 8 }} />
                  ) : null}
                  <Text style={styles.normalText20px}>{item.title}</Text>
                </div>
              </div>
              <img
                src={
                  (index === 0 && expanded0) || (index === 1 && expanded1) || (index === 2 && expanded2)
                    ? arrowOpen
                    : arrowClose
                }
                width="16"
                height="16"
                style={{ border: 'none' }}
              />
            </div>
          </div>
        </div>

        {(index === 0 && expanded0) || (index === 1 && expanded1) || (index === 2 && expanded2) ? (
          index === 0 ? (
            <div style={{ width: '100%', backgroundColor: '#EBEBEB', padding: '16px', overflow: 'hidden' }}>
              {/* <Text style={styles.steps}>{item.step1}</Text>
            <div
              style={{
                position: 'relative',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                // backgroundColor: 'red',
              }}
            > 
              <Text style={styles.normalText}>{item.description}</Text>
               <div ref={qrCodeRef}>
                <FPSPanelContent
                  mcc={FPS_MCC}
                  currency={FPS_CURRENCY}
                  fpsId={companyCode == '8' ? '5169909' : '7222417'}
                  reference={paymentDetail?.policyNumberNew}
                  amount={paymentDetail?.premiumAmountHKD?.replace(/,/g, '')}
                  merchantName={companyCode == '8' ? 'Generali Life (Hong Kong)' : 'Assicurazioni Generali S.'}
                ></FPSPanelContent>
              </div> 
               <img
                onClick={handleDownloadQRCode}
                src={download}
                width="24"
                height="24"
                style={{ border: 'none', position: 'absolute', right: '0', top: '0' }}
              />
            </div> */}
              <ul style={{ marginLeft: '16px' }}>
                <li>
                  <Text style={{ ...styles.normalText, whiteSpace: 'pre-line' }}>{item.description}</Text>
                </li>
                <li>
                  <Text style={{ ...styles.normalText, whiteSpace: 'pre-line' }}>{item.description2}</Text>
                </li>
              </ul>

              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => navigateToCreditCardPayment('FPS')}
                  style={{
                    width: '80%',
                    borderColor: '#c21b17',
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    margin: 10,
                  }}
                >
                  {t('shortfallPayment.pay2')}
                </Button>
                {/* {Number(premiumAmountHKD.replace(/,/g, '')) < 400000 && (
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => handleComplete()}
                  style={{
                    width: '80%',
                    borderColor: '#c21b17',
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    margin: 10,
                  }}
                >
                  {t('Payment.PaymentComplete')}
                </Button>
              )} */}
                {/* {Number(premiumAmountHKD.replace(/,/g, '')) >= 400000 && (
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => handleUpload('FPS')}
                  style={{
                    width: '80%',
                    borderColor: '#c21b17',
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    margin: 10,
                  }}
                >
                  {t('Payment.UploadProof')}
                </Button>
              )} */}
              </div>
              {/* {Number(premiumAmountHKD.replace(/,/g, '')) < 400000 && (
              <div style={{ width: '100%' }}>
                <div style={{ height: 1, marginTop: '16px', backgroundColor: '#CCCCCC' }} />
                <div style={{ paddingTop: '16px' }}>
                  <Text style={styles.steps}>{item.step2}</Text>
                  <Text style={styles.normalText}>{item.description3}</Text>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                    }}
                  >
                    <Button
                      block
                      type="primary"
                      size="large"
                      onClick={() => handleComplete()}
                      style={{
                        width: '80%',
                        borderColor: '#c21b17',
                        fontFamily: 'Roboto500',
                        fontSize: '20px',
                        height: '56px',
                        margin: 10,
                      }}
                    >
                      {t('Payment.PaymentComplete')}
                    </Button>
                  </div>
                </div>
              </div>
            )} */}

              {/* {Number(premiumAmountHKD.replace(/,/g, '')) >= 400000 && (
            <div style={{ width: '100%' }}>
              <div style={{ height: 1, marginTop: '16px', marginBottom: '16px', backgroundColor: '#CCCCCC' }} />
              <Text style={styles.steps}>{t('Payment.UploadProof2')}</Text>
              <Text style={styles.normalText}>{t('Payment.UploadProofDesc')}</Text>
              <Text style={{ ...styles.normalText, whiteSpace: 'pre-line' }}>{t('Payment.UploadDesc')}</Text>{' '}
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => handleUpload('FPS')}
                  style={{
                    width: '80%',
                    borderColor: '#c21b17',
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    margin: 10,
                  }}
                >
                  {t('Payment.UploadProof')}
                </Button>
              </div>
            </div>
            )} */}
            </div>
          ) : index === 1 ? (
            <div
              style={{ width: '100%', backgroundColor: '#EBEBEB', padding: '16px', margin: '0', overflow: 'hidden' }}
            >
              {/* <Text style={styles.normalText}>{item.description}</Text> */}
              <ul style={{ marginLeft: '16px' }}>
                {payTips.map((tip) => (
                  <li key={tip.i18nKey}>
                    <Text style={{ ...styles.normalText, whiteSpace: 'pre-line' }}>
                      {isEnglish ? tip.langEn : tip.langZhTw}
                    </Text>
                  </li>
                ))}
              </ul>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                }}
              >
                <Button
                  block
                  type="primary"
                  size="large"
                  onClick={() => navigateToCreditCardPayment('creditCard')}
                  style={{
                    width: '80%',
                    borderColor: '#c21b17',
                    fontFamily: 'Roboto500',
                    fontSize: '20px',
                    height: '56px',
                    margin: 10,
                  }}
                >
                  {t('shortfallPayment.pay2')}
                </Button>
              </div>
            </div>
          ) : (
            <div style={styles.container}>
              <div style={styles.table}>
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.steps}>{t('Payment.Step1')}</Text>
                  <Text style={styles.tableHeader}>{t('Payment.BankDesc')}</Text>
                </div>

                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />

                <div style={styles.tableRow}>
                  <div style={styles.tableColumn}>
                    <Text style={styles.tableHeader}>{t('Payment.PayeeName')}</Text>
                    <Text style={styles.normalText}>
                      {isEnglish ? companyNameData?.companyName : companyNameData?.companyNameTC}
                    </Text>
                  </div>
                  <div style={styles.tableColumn}>
                    <Text style={styles.tableHeader}>{t('Payment.BankName')}</Text>
                    <Text style={styles.normalText}>{isEnglish ? 'Citibank N.A.' : '花旗銀行'}</Text>
                  </div>
                </div>

                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />

                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('Payment.BankAddress')}</Text>
                  <Text style={styles.normalText}>
                    {isEnglish ? 'Champion Tower, Three Garden Road, Central, HongKong' : '香港中環花園道三號冠君大厦'}
                  </Text>
                </div>

                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('Payment.SwiftCode')}</Text>
                  <Text style={styles.normalText}>{'CITIHKHX'}</Text>
                </div>
                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('shortfallPayment.bankTransfer.bankAccountNumber')}</Text>
                  <Text style={styles.normalText}>
                    {companyCode == '8'
                      ? isEnglish
                        ? '006-391-62520091 (HKD Account)'
                        : '006-391-62520091 (港元戶口)'
                      : isEnglish
                      ? '006-391-08661316 (HKD Account)'
                      : '006-391-08661316 (港元戶口)'}
                  </Text>
                  <Text style={styles.normalText}>
                    {companyCode == '8'
                      ? isEnglish
                        ? '006-391-62520113 (USD Account)'
                        : '006-391-62520113 (美元戶口)'
                      : isEnglish
                      ? '006-391-08681678 (USD Account)'
                      : '006-391-08681678 (美元戶口)'}
                  </Text>
                </div>
                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={styles.tableRow}>
                  <div style={styles.tableColumn}>
                    <Text style={styles.tableHeader}>{t('Payment.PayeeName')}</Text>
                    <Text style={styles.normalText}>
                      {isEnglish ? companyNameData?.companyName : companyNameData?.companyNameTC}
                    </Text>
                  </div>
                  <div style={styles.tableColumn}>
                    <Text style={styles.tableHeader}>{t('Payment.BankName')}</Text>
                    <Text style={styles.normalText}>{isEnglish ? 'HSBC' : '匯豐銀行'}</Text>
                  </div>
                </div>

                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />

                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('Payment.BankAddress')}</Text>
                  <Text style={styles.normalText}>
                    {isEnglish
                      ? "Head Office, 1 Queen's Road, Central, Hong Kong"
                      : '香港中環皇后大道中1號匯豐總行大廈'}
                  </Text>
                </div>

                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('Payment.SwiftCode')}</Text>
                  <Text style={styles.normalText}>{'HSBCHKHHHKH'}</Text>
                </div>
                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.tableHeader}>{t('shortfallPayment.bankTransfer.bankAccountNumber')}</Text>
                  <Text style={styles.normalText}>
                    {companyCode == '8'
                      ? isEnglish
                        ? '004-848-739330-292 (HKD Account)'
                        : '004-848-739330-292 (港元戶口)'
                      : isEnglish
                      ? '004-600-330336002 (HKD Account)'
                      : '004-600-330336002 (港元戶口)'}
                  </Text>
                  <Text style={styles.normalText}>
                    {companyCode == '8'
                      ? isEnglish
                        ? '004-848-739330-274 (USD Account)'
                        : '004-848-739330-274 (美元戶口)'
                      : isEnglish
                      ? '004-848-753158201 (USD Account)'
                      : '004-848-753158201 (美元戶口)'}
                  </Text>
                </div>
                <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <Text style={styles.normalText}>{t('Payment.BankDesc2')}</Text>
                </div>

                <div style={{ ...styles.tableColumn, width: '100%' }}>
                  <div style={{ height: 1, backgroundColor: '#CCCCCC' }} />
                  <div style={{ paddingTop: '16px' }}>
                    <Text style={styles.steps}>{t('Payment.UploadProof2')}</Text>
                    <Text style={styles.tableHeader}>{t('Payment.UploadProofDesc')}</Text>
                    <Text style={{ ...styles.normalText, whiteSpace: 'pre-line' }}>{t('Payment.UploadDesc2')}</Text>
                    <div
                      style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                      }}
                    >
                      <Button
                        block
                        type="primary"
                        size="large"
                        onClick={() => handleUpload('Bank')}
                        style={{
                          width: '80%',
                          borderColor: '#c21b17',
                          fontFamily: 'Roboto500',
                          fontSize: '20px',
                          height: '56px',
                          margin: 10,
                        }}
                      >
                        {t('Payment.UploadProof')}
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )
        ) : null}
      </>
    ),
    [
      expanded0,
      expanded1,
      expanded2,
      Text,
      // paymentDetail,
      handleUpload,
      navigateToCreditCardPayment,
      // handleComplete,
      toggleExpanded,
      // premiumAmountHKD,
      companyCode,
      isEnglish,
      companyNameData,
      t,
      payTips,
    ],
  );

  return (
    <>
      <GreetingSection pageName={t('life.Payment.payment')} showicon={true} />
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: '40px' }}>
        <div style={{ width: '1384px', background: '#F0F2F5' }}>
          <ResponsiveContainer
            style={{
              // padding: 16,
              backgroundColor: 'white',
            }}
          >
            <div
              style={{
                padding: 16,
                borderBottom: '1px solid #ccc',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                // backgroundColor: 'yellow',
              }}
            >
              <div
                style={{
                  borderRight: '1px solid #ccc',
                  width: '50%',
                  backgroundColor: 'white',
                }}
              >
                <Text style={styles.tableHeader}>{t('registration.policyNumberLabel')}</Text>
                <Text style={styles.normalText20px}>{policyNumber}</Text>
              </div>
              <div style={{ width: '50%', paddingLeft: 10 }}>
                <Text style={styles.tableHeader}>{t('Payment.PremiumDueDate')}</Text>
                <Text style={styles.normalText20px}>
                  {i18n.language == 'en' ? premiumDueDate || '' : changeDataFun(premiumDueDate || '')}
                </Text>
              </div>
            </div>
          </ResponsiveContainer>
          <ResponsiveContainer style={{ background: 'white' }}>
            <div
              style={{
                borderBottom: '1px solid #ccc',

                // onClick={toggleExpand},
                backgroundColor: 'pink',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: 'white',
                  padding: 16,
                }}
                onClick={() => paymentStateCode !== 'LevyOverdue' && setExpanded((show) => !show)} // 添加判断条件
              >
                <div style={{ flex: 1 }}>
                  <Text style={styles.tableHeader}>
                    {paymentStateCode == 'LevyOverdue'
                      ? t('Payment.OutstandingPayment')
                      : t('Payment.OutstandingPayment2')}
                  </Text>
                  {paymentStateCode != 'LevyOverdue' && (
                    <Text style={styles.normalText20px}>{t('Payment.TotakPremium')}</Text>
                  )}
                  <Text style={styles.normalText20px}>{`${currency} ${premiumAmount}`}</Text>
                </div>
                {paymentStateCode != 'LevyOverdue' && (
                  <img
                    src={expanded ? arrowOpen : arrowClose}
                    width="16"
                    height="16"
                    style={{ border: 'none' }}
                    alt="Arrow"
                  />
                )}
              </div>
              {/* <div style={{ marginTop: 12 }}></div> */}
            </div>
            <div />

            {expanded && (
              <div style={{ backgroundColor: '#ebebeb' }}>
                <div
                  style={{
                    padding: 16,
                    paddingLeft: 54,
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid #ccc',
                  }}
                >
                  <Text style={styles.tableHeader}>{t('Payment.SemiAnnual')}</Text>
                  <Text style={styles.normalText20px}>{`${currency} ${semiAnnualPremiumAmount}`}</Text>
                </div>
                <div
                  style={{
                    padding: 16,
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid #ccc',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <img src={plus} width="30" height="30" style={{ border: 'none' }} />

                  <div>
                    <Text style={styles.tableHeader}>{t('Payment.TotalLevyAmount')}</Text>
                    <Text style={styles.normalText20px}>{`${currency} ${levyAmount}`}</Text>
                  </div>
                </div>
                <div
                  style={{
                    padding: 16,
                    backgroundColor: 'transparent',
                    borderBottom: '1px solid #ccc',
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                  }}
                >
                  <img src={minus} width="30" height="30" style={{ border: 'none' }} />

                  <div>
                    <Text style={styles.tableHeader}>{t('Payment.Overpaid')}</Text>
                    <Text style={styles.normalText20px}>{`${currency} ${discountAmount}`}</Text>
                  </div>
                </div>
              </div>
            )}
          </ResponsiveContainer>
          <ResponsiveContainer
            style={{
              backgroundColor: 'white',
            }}
          >
            <div
              style={{
                borderBottom: '1px solid #ccc',
                padding: 16,
              }}
            >
              <Text style={styles.tableHeader}>
                {paymentStateCode !== 'LevyOverdue'
                  ? t('Payment.OutstandingPaymentHKD')
                  : t('Payment.OutstandingPaymentHKD2')}
              </Text>
              <Text style={styles.normalText20px}>{`${hkdCurrency} ${premiumAmountHKD}`}</Text>
            </div>
          </ResponsiveContainer>
          {currency !== '港元' && currency != 'HKD' && (
            <ResponsiveContainer
              style={{
                backgroundColor: 'white',
              }}
            >
              <div
                style={{
                  borderBottom: '1px solid #ccc',
                  padding: 16,
                }}
              >
                <Text style={styles.tableHeader}>
                  {' '}
                  {`${currency} 1 = ${hkdCurrency} ${exchangeRate} ${t('Payment.AsOf')} ${
                    i18n.language === 'en' ? exchangeDate || '' : changeDataFun(exchangeDate)
                  }`}
                </Text>
              </div>
            </ResponsiveContainer>
          )}
          <ResponsiveContainer
            style={{
              backgroundColor: 'white',
              marginBottom: 20,
            }}
          >
            <div
              style={{
                padding: 16,
              }}
            >
              <Text style={styles.normalText}>{t('Payment.OnlyAccept')}</Text>
              <Text style={styles.normalText}>{t('Payment.ByBeneficiary')}</Text>
            </div>
          </ResponsiveContainer>

          <ResponsiveContainer style={{ background: 'white' }}>
            <VStack>
              <Text style={styles.normalText33px}>{t('shortfallPayment.selectPaymentMethod2')}</Text>
              <div>
                {surgeryData.map((item: SurgeryItem, index) => (
                  <div key={item.id.toString()}>{renderClassificationItem({ item, index })}</div>
                ))}
              </div>
              {/* <PayByCreditVISA shortfalls={shortfalls} />

            <MenuItem
              testID='paymentFpsMenu'
              text={'FPS'}
              onPress={navigateToFpsPayment}
              icon={paymentFps}
            />

            <OtherPaymentMethods />

            <div style={styles.selectPaymentInfoWrapper}>
              <InfoIcon style={styles.selectPaymentInfoIcon} />
              <Text body2 style={styles.selectPaymentInfoText}>
                {t('shortfallPayment.info')}
              </Text>
            </div> */}
            </VStack>
          </ResponsiveContainer>
        </div>
      </div>
    </>
  );
};
